import TabScrollButton from "@material-ui/core/TabScrollButton";
import { withStyles } from "@material-ui/core/styles";
import { useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { styled, useTheme } from "@mui/material/styles";
import * as React from "react";
import { useParams } from "react-router-dom";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  childHeight?: string;
}

function _TabPanel({
  children,
  value,
  index,
  childHeight,
  ...other
}: TabPanelProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box
          sx={{
            p: { xs: "unset", md: 3 },
            borderLeft: "1px solid #C1C7CB",
            borderRight: "1px solid #C1C7CB",
            borderBottom: "1px solid #C1C7CB",
          }}
          className="visible-print "
        >
          <Box
            className="tabsScroll"
            style={{
              height: childHeight ? childHeight : isMobile ? "" : "50vh",
            }}
            id="scrollableDiv"
            paddingRight={{ xs: "unset", md: "3vh" }}
            paddingX={{ xs: "20px", md: "unset" }}
          >
            <Box
              marginLeft={{ xs: "unset", md: "1.5vh" }}
              style={{ direction: "rtl", height: "100%" }}
            >
              <Typography sx={{ height: "100%" }}>{children}</Typography>
            </Box>
          </Box>
        </Box>
      )}
    </div>
  );
}

function tabProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
interface tabsInterface {
  tab: any;
  colorTab: string;
  childHeight?: string;
  setActiveTab?: any;
}

export default function TabPanelCmp({
  tab,
  colorTab,
  childHeight,
  setActiveTab,
}: tabsInterface) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    setActiveTab !== undefined && setActiveTab(newValue);
  };

  const StyledTab = styled(Tab)({
    "&.Mui-selected": {
      color: "#1d4a87 !important",
      background: "white !important",
      alignItems: "center",
      borderRight: "2px solid #C1C7CB",
      borderLeft: "2px solid #C1C7CB !important",
      borderBottom: "2px solid white !important",
      boxShadow: "0 4px 0 -2px white !important",
    },
    "&.MuiSvgIcon-root": {
      width: "24px",
      height: "24px",
    },
    "&.MuiTab-root": {
      color: "#1d4a87 !important",
    },
  });

  const MyTabScrollButton = withStyles((theme) => ({
    root: {
      width: 28,
      overflow: "hidden",
      transition: "width 0.5s",
      direction: "rtl",

      "&.Mui-disabled": {
        width: 0,
      },
    },
  }))(TabScrollButton);

  return (
    <Box
      sx={{
        marginTop: "1.9vh",
        direction: "rtl",
        overflowX: "auto",
        paddingBottom: "2vh",
      }}
    >
      <Box
        style={{
          overflowX: "auto",
          borderBottom: tab.length > 0 ? "1px solid #c1c7cb" : "",
        }}
      >
        {/* */}
        <Tabs
          variant="scrollable"
          scrollButtons={false}
          ScrollButtonComponent={MyTabScrollButton}
          allowScrollButtonsMobile
          value={value}
          onChange={handleChange}
          style={{ overflowX: "auto", width: "max-content" }}
          TabIndicatorProps={{
            style: {
              background: colorTab,
              top: 0,
              height: "4px ",
            },
          }}
        >
          {tab.map((item: any) => (
            //
            <StyledTab
              label={<div style={{ marginRight: "5px" }}>{item.title}</div>}
              icon={item.icon}
              {...tabProps(0)}
              key={item.id}
              style={{
                borderLeft: "2px solid white",
                height: "50px",
                minHeight: "50px",
                alignItems: "center",
                background: "#F6F8F9",
                flexDirection: "row",
                padding: "20px",
                fontSize: "13px",
                fontWeight: "bold",
              }}
            />
          ))}
        </Tabs>
      </Box>
      {tab.map((item: any) => (
        <_TabPanel
          value={value}
          index={item.id}
          key={item.id}
          childHeight={childHeight}
        >
          {item.child}
        </_TabPanel>
      ))}
    </Box>
  );
}
